import React from 'react';
import { BarChart, Bar, XAxis, ResponsiveContainer, Cell, Tooltip } from 'recharts';

import { ReactComponent as PriceIcon } from '../../../assets/icons/price-increase-icon.svg';
import { brandColors, brandText } from '../../../config/branding';

interface ChartData {
  label: string;
  value: number;
  fill?: string; // Optional property for fill color
}

interface ChartSectionProperties {
  title: string;
  subtitle: string;
  submenutitle: string;
  value: string;
  percentage: number;
  data: ChartData[];
  chartType: 'revenue' | 'powerConsumed';
}
/**
 * Chart component renders a bar chart to display power consumption data.
 * @returns {JSX.Element} - The rendered bar chart component.
 */
function ChartSection({
  title,
  subtitle,
  submenutitle,
  value,
  percentage,
  data,
  chartType,
}: ChartSectionProperties): JSX.Element {
  const highestValue = Math.max(...data.map((item) => item.value));

  const processedData: ChartData[] = data.map((item) => ({
    ...item,
    fill: item.value === highestValue ? brandColors.primary : brandColors.reportChart,
  }));

  console.log('processedData', processedData);

  return (
    <div className="chart-card">
      <div className="content-section">
        <h2 className="title">{value}</h2>
        <p className="subtitle">{title}</p>
        <div className="percentage-row">
          <span className="percentage">
            {percentage}% <PriceIcon />
          </span>
          <span className="more-text">{subtitle}</span>
        </div>
        <div className="submenu-container">
          <span className="more-text">{submenutitle}</span>
        </div>
      </div>
      <div className="chart-section">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={processedData}>
            <Tooltip
              cursor={{ fill: '#f5f5f5' }} // Optional: Customize cursor highlight
              contentStyle={{
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                borderRadius: '5px',
              }} // Optional: Customize tooltip style
              labelStyle={{ color: '#666', fontWeight: 'bold' }}
              formatter={(singleValue: number) => [
                `${singleValue} ${chartType === 'revenue' ? brandText.currency : 'Kwh'}`,
                `${chartType === 'revenue' ? 'Revenue' : 'Power Consumed'}`,
              ]} // Optional: Customize value display
            />
            {/* <CartesianGrid strokeDasharray="3 3" vertical={false} /> */}
            <XAxis
              dataKey="label"
              axisLine={false}
              tickLine={false}
              tick={{ fill: '#666', fontSize: 12 }}
            />
            <Bar dataKey="value" radius={[10, 10, 0, 0]} barSize={12}>
              {processedData.map((entry) => (
                <Cell key={entry.label} fill={entry.fill} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default ChartSection;
